// Temporary toggle for marketplace mock products.
// Change only this value:
// - true: use mocked marketplace products
// - false: use marketplace products from API
export const mockMarketplaceScreenEnabled = false;
